import { useState, useEffect } from "react";
import { sendEvent, EventName, EventParameter } from "../utils/UsageAnalytics";

const FOLLOW_UP_SUGGESTIONS_KEY = "showFollowUpSuggestions";

export const useFollowUpSuggestions = () => {
  const [showFollowUpSuggestions, setShowFollowUpSuggestions] =
    useState<boolean>(true);

  // Load setting from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(FOLLOW_UP_SUGGESTIONS_KEY);
    if (stored !== null) {
      setShowFollowUpSuggestions(JSON.parse(stored));
    }
  }, []);

  // Update localStorage when setting changes
  const updateShowFollowUpSuggestions = (value: boolean) => {
    setShowFollowUpSuggestions(value);
    sendEvent(EventName.SettingsChanged, {
      [EventParameter.SettingName]: "follow_up_suggestions",
      [EventParameter.SettingValue]: value.toString(),
    });
    localStorage.setItem(FOLLOW_UP_SUGGESTIONS_KEY, JSON.stringify(value));
  };

  return {
    showFollowUpSuggestions,
    setShowFollowUpSuggestions: updateShowFollowUpSuggestions,
  };
};
